
import { RouteObject } from 'react-router-dom';
import HomePage from '../pages/home/page';
import AboutPage from '../pages/about/page';
import ExperiencesPage from '../pages/experiences/page';
import DesertExperiencePage from '../pages/experiences/desert/page';
import ForestExperiencePage from '../pages/experiences/forest/page';
import LakesideExperiencePage from '../pages/experiences/lakeside/page';
import MountainExperiencePage from '../pages/experiences/mountain/page';
import RetreatsPage from '../pages/retreats/page';
import InvestmentsPage from '../pages/investments/page';
import InvestmentPackagesPage from '../pages/investment-packages/page';
import InvestmentDetailPage from '../pages/investment-detail/page';
import InvestmentPortfolioPage from '../pages/investments/portfolio/page';
import InvestmentProcessPage from '../pages/investments/process/page';
import InvestmentReturnsPage from '../pages/investments/returns/page';
import StartInvestingPage from '../pages/start-investing/page';
import DealershipPage from '../pages/dealership/page';
import StarterDealershipPage from '../pages/dealership/starter/page';
import GrowthDealershipPage from '../pages/dealership/growth/page';
import PremiumDealershipPage from '../pages/dealership/premium/page';
import PartnershipPage from '../pages/partnership/page';
import ContactPage from '../pages/contact/page';
import BookPage from '../pages/book/page';
import ConsultationPage from '../pages/consultation/page';
import ConsultationSchedulingPage from '../pages/consultation-scheduling/page';
import CareersPage from '../pages/careers/page';
import CareersApplicationPage from '../pages/careers/application/page';
import CatalogPage from '../pages/catalog/page';
import PressPage from '../pages/press/page';
import SustainabilityPage from '../pages/sustainability/page';
import PrivacyPage from '../pages/privacy/page';
import TermsPage from '../pages/terms/page';
import PaymentSuccessPage from '../pages/payment-success/page';
import PaymentCancelledPage from '../pages/payment-cancelled/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/experiences',
    element: <ExperiencesPage />
  },
  {
    path: '/experiences/desert',
    element: <DesertExperiencePage />
  },
  {
    path: '/experiences/forest',
    element: <ForestExperiencePage />
  },
  {
    path: '/experiences/lakeside',
    element: <LakesideExperiencePage />
  },
  {
    path: '/experiences/mountain',
    element: <MountainExperiencePage />
  },
  {
    path: '/retreats',
    element: <RetreatsPage />
  },
  {
    path: '/investments',
    element: <InvestmentsPage />
  },
  {
    path: '/investment-packages',
    element: <InvestmentPackagesPage />
  },
  {
    path: '/investment-detail',
    element: <InvestmentDetailPage />
  },
  {
    path: '/investment-detail/:id',
    element: <InvestmentDetailPage />
  },
  {
    path: '/investments/portfolio',
    element: <InvestmentPortfolioPage />
  },
  {
    path: '/investments/process',
    element: <InvestmentProcessPage />
  },
  {
    path: '/investments/returns',
    element: <InvestmentReturnsPage />
  },
  {
    path: '/start-investing',
    element: <StartInvestingPage />
  },
  {
    path: '/dealership',
    element: <DealershipPage />
  },
  {
    path: '/dealership/starter',
    element: <StarterDealershipPage />
  },
  {
    path: '/dealership/growth',
    element: <GrowthDealershipPage />
  },
  {
    path: '/dealership/premium',
    element: <PremiumDealershipPage />
  },
  {
    path: '/partnership',
    element: <PartnershipPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/book',
    element: <BookPage />
  },
  {
    path: '/consultation',
    element: <ConsultationPage />
  },
  {
    path: '/consultation-scheduling',
    element: <ConsultationSchedulingPage />
  },
  {
    path: '/careers',
    element: <CareersPage />
  },
  {
    path: '/careers/application',
    element: <CareersApplicationPage />
  },
  {
    path: '/catalog',
    element: <CatalogPage />
  },
  {
    path: '/press',
    element: <PressPage />
  },
  {
    path: '/sustainability',
    element: <SustainabilityPage />
  },
  {
    path: '/privacy',
    element: <PrivacyPage />
  },
  {
    path: '/terms',
    element: <TermsPage />
  },
  {
    path: '/payment-success',
    element: <PaymentSuccessPage />
  },
  {
    path: '/payment-cancelled',
    element: <PaymentCancelledPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
